import * as React from 'react'
import { card } from '@/styles/theme/components/card'
import type { CardProps } from './types'

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
    ({ className = '', children, ...props }, ref) => (
        <div
            ref={ref}
            className={`${card.base} ${className}`}
            {...props}
        >
            {children}
        </div>
    )
)

export const CardHeader = React.forwardRef<HTMLDivElement, CardProps>(
    ({ className = '', children, ...props }, ref) => (
        <div
            ref={ref}
            className={`${card.header} ${className}`}
            {...props}
        >
            {children}
        </div>
    )
)

export const CardTitle = React.forwardRef<HTMLHeadingElement, CardProps>(
    ({ className = '', children, ...props }, ref) => (
        <h3
            ref={ref}
            className={`${card.title} ${className}`}
            {...props}
        >
            {children}
        </h3>
    )
)

export const CardContent = React.forwardRef<HTMLDivElement, CardProps>(
    ({ className = '', children, ...props }, ref) => (
        <div
            ref={ref}
            className={`${card.content} ${className}`}
            {...props}
        >
            {children}
        </div>
    )
)

export const CardDescription = React.forwardRef<HTMLParagraphElement, CardProps>(
    ({ className = '', children, ...props }, ref) => (
        <p
            ref={ref}
            className={`${card.description} ${className}`}
            {...props}
        >
            {children}
        </p>
    )
)

export const CardFooter = React.forwardRef<HTMLDivElement, CardProps>(
    ({ className = '', children, ...props }, ref) => (
        <div
            ref={ref}
            className={`${card.footer} ${className}`}
            {...props}
        >
            {children}
        </div>
    )
)

Card.displayName = 'Card'
CardHeader.displayName = 'CardHeader'
CardTitle.displayName = 'CardTitle'
CardContent.displayName = 'CardContent'
CardDescription.displayName = 'CardDescription'
CardFooter.displayName = 'CardFooter'